import api from 'src/utils/api/core'

export function updateTugStages(data) {
  return api.put(`/pilotage_tug_stages`, data);
}

// Delete a tug stage by uuid
export function deleteTugStage(uuid) {
  return api.delete(`/pilotage_tug_stages/${uuid}`)
}

// Update (rename) a tug stage by uuid
export function updateTugStage(uuid, data) {
  return api.put(`/pilotage_tug_stages/${uuid}`, data)
}

export function getTugStages(pilotageUuid) {
  return api.get(`/pilotage_tug_stages/pilotageId/${pilotageUuid}`)
}

export function addTugStage(data) {
  return api.post(`/pilotage_tug_stages`, data)
}
